module.exports = __webpack_public_path__ + "static/media/WA_footy_lives_here_logo.6ddc8c10.png";